export default __webpack_public_path__ + "static/biocultus-a9d358554a288c949f34984dfe1550fb.svg";